module.exports = __webpack_public_path__ + "img/code-css-xl.dcddd0af.webp";